<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: `/sites`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
      <router-link class="paper-action" :to="{ path: `/sites/${site.id}/edit`}"><span>{{ $t('edit') }}</span><heim-icon icon="chevron-right"></heim-icon></router-link>
    </header>
    <main class="site-details">
      <section class="info">
        <heim-card>
          <main>
            <div class="row">
              <h1>{{ site.name }}</h1>
              <span>{{ site.url }}</span>
            </div>
          </main>
        </heim-card>
        <heim-card class="endpoints">
          <header>
            <h1>{{ $t('endpoints') }}</h1>
          </header>
          <main>
            <div class="row" v-for="(endpoint, idx) in site.Endpoints" :key="`endpoint-${idx}`">
              <div class="details-row">
                <span>{{ endpoint.id }} - <a :title="endpoint.url" :href="endpoint.url" target="_blank">{{ endpoint.url }}</a></span>
                <span class="badge">{{ endpoint.integrity_key }}</span>
              </div>
            </div>
          </main>
        </heim-card>
        <heim-card class="monitoring">
          <header class="header left"><h1>{{ $t('monitoring') }}</h1></header>
          <main>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('referenceTime') }}</span>
                <span class="badge">{{ site.reference_time?site.reference_time/1000 + 's':'n/a' }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('beforeNotification') }}</span>
                <span class="badge">{{ site.nb_occurence }} {{ $t('occurences') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('server') }}</span>
                <router-link v-if="site.Server" :to="{ path: `/servers/${site.Server.id}/details` }">{{ site.Server.name }}</router-link>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('type') }}</span>
                <router-link v-if="site.Type" :to="{ path: `/types/${site.Type.id}/details` }">{{ site.Type.type }}</router-link>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('pingInterval') }}</span>
                <span class="badge">{{ site.interval/1000 }} {{ $t('seconds') }}</span>
              </div>
            </div>
          </main>
        </heim-card>
        <heim-card class="hostingCosts">
          <header class="header left"><h1>{{ $t('hostingCosts') }}</h1></header>
          <main>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('invoicedAmount') }}</span>
                <span class="badge">{{ $n(site.hosting_cost, 'currency') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('startDate') }}</span>
                <span class="badge">{{ site.hosting_date_start ? $d(new Date(site.hosting_date_start), 'short') : "n/a" }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('endDate') }}</span>
                <span class="badge">{{ site.hosting_date_end ? $d(new Date(site.hosting_date_end), 'short') : "n/a"}}</span>
              </div>
            </div>
          </main>
        </heim-card>
        <heim-card>
          <header><h1>{{ $t('user') }}</h1></header>
          <main>
            <heim-user-card v-for="user in site.Users" :user="user" :key="`user-${user.id}`"></heim-user-card>
          </main>
        </heim-card>
      </section>
      <heim-card class="stats">
        <header class="header left">
          <h1>{{ $t('stats') }}</h1>
        </header>
        <main>
          <heim-line :chart-data="logs" :options="options"></heim-line>
        </main>
      </heim-card>
    </main>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import heimLine from "@/components/chart/heim-line.vue";
import HeimUserCard from "@/components/layout/card/heim-user-card.vue";
import { mapState } from "vuex";

export default {
  name: "SitesDetail",
  components: {
    HeimIcon,
    HeimCard,
    heimLine,
    HeimUserCard
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm",
                unit: "hour"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getSite", { id });
    this.$store.dispatch("getSiteLogs", { id });

    this.$watch(
      vm => vm.site,
      val => {
        this.$store.dispatch("setTitle", `Site - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({ site: state => state.sitesState.site }),
    ...mapState({ siteLogs: state => state.sitesState.siteLogs }),
    logs() {
      const logs = this.$store.getters.getSiteLogs(`site-${this.site.id}`);
      if (!logs) return { label: [], datasets: [] };
      const filteredLog = logs.slice(Math.max(logs.length - 70, 1));
      const datasets = [];
      this.site.Endpoints.map((endpont, index) => {
        const logs = filteredLog.filter(log => log.uri == endpont.url);
        const color = this.colors()[index].color;

        datasets.push({
          label: endpont.id,
          data: logs.map(log => log.response_time),
          borderColor: [color],
          borderWidth: 1,
          fill: false
        });
      });
      filteredLog.map;
      const data = {
        labels: filteredLog.map(log => log.createdAt),
        datasets: datasets
      };
      return data;
    }
  },
  methods: {
    colors() {
      const colors = [
        { name: "blue", color: "#148DA0" },
        { name: "red", color: "#FF0000" },
        { name: "green", color: "#008000" },
        { name: "purple", color: "#800080" },
        { name: "orange", color: "	#FF6600" },
        { name: "black", color: "#000000" },
        { name: "crimson", color: "#DC143C" },
        { name: "Brown", color: "#964B00" },
        { name: "Burgundy", color: "#800020" },
        { name: "pink", color: "#FD6C9E" }
      ];

      return colors;
    }
  }
};
</script>

<style scoped>
.site-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.endpoints .details-row > span {
  display: inline-block;
  max-width: 16em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.site-details > .paper-card,
.site-details > .info {
  width: 100%;
  margin-right: 0;
}
.site-details .stats,
.site-details .monitoring,
.site-details .hostingCosts {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.endpoints {
  margin-bottom: 1em;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.endpoints {
  border-radius: 0;
}

.details-row span:first-child {
  padding: 0.2rem 0;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .site-details {
    flex-wrap: nowrap;
  }
  .site-details > .paper-card,
  .site-details > .info {
    width: 50%;
    margin-right: 1em;
  }
}
</style>
